import cmp from '../../lib/cmp';
import { one } from '../../lib/dom/on';
import selectByClassName from '../../lib/dom/select-by-class';
import trackReadMoreView from '../../lib/track-event/read-more-view';
import smSectionText from '../sm-landing-appstore-app-1-section-text/sm-landing-appstore-app-1-section-text';
import './sm-landing-appstore-app-1-short-description.less';
import { isRtl } from '../../lib/document-dir-utils';



export const DESCRIPTION_LAYOUT_CLASS = 'sm-landing-appstore-app-1-short-description__layout';

const getDeveloperInfoTemplate = (vendor, isRtlDirection = false) => `
    <div class="sm-landing-appstore-app-1-short-description__developer">
      <!--<div class="sm-landing-appstore-app-1-short-description__developer-icon"></div>-->
        <div class="sm-landing-appstore-app-1-short-description__developer-name${isRtlDirection ? '-rtl' : ''}">${vendor}</div>
        <div class="sm-landing-appstore-app-1-short-description__developer-title">${__('sm@_developer')}</div>
      <div class="sm-landing-appstore-app-1-short-description__developer-arrow${isRtlDirection ? '-rtl' : ''}"></div>
    </div>
`;

const template = ($cmp, { description, vendor }) => {
  return `
    <div class="sm-landing-appstore-app-1-short-description">
      <div class="${DESCRIPTION_LAYOUT_CLASS}">
        ${vendor ? `
          <div class="sm-landing-appstore-app-1-short-description__developer-ipad">
            <div class="sm-landing-appstore-app-1-short-description__developer-ipad-in">
              <div class="sm-landing-appstore-app-1-short-description__developer-ipad-title">${__('sm@_developer')}</div>
              <div class="sm-landing-appstore-app-1-short-description__developer-ipad-name-wr">
                <div class="sm-landing-appstore-app-1-short-description__developer-ipad-name">${vendor}</div>
              </div>
            </div>
          </div>
        ` : ''}

        <div class="sm-landing-appstore-app-1-short-description__text-wr">
          ${$cmp('sm-landing-appstore-app-1-short-description__text', smSectionText, { text: description })}
        </div>
        ${vendor ? getDeveloperInfoTemplate(vendor, isRtl()) : ''}
      </div>
    </div>
  `;
};



export default cmp(null, template, (element) => {
  one(selectByClassName(element, DESCRIPTION_LAYOUT_CLASS), 'click', trackReadMoreView);
});




// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-short-description/sm-landing-appstore-app-1-short-description.js